export enum EntityTypeId {
    InstitutionEntity = "26bc1365-408c-5afa-affd-d705426afaef",
    PersonEntity = "546688f6-6fd6-5891-8813-4e0e91f9abe2",
    TodoEntity = "343e989f-ff81-5b98-b45d-b0451722e1e0",
    Akquise = "e8480e5e-c811-573b-90e6-d589a2a8d034",
    OpportunityEntity = "ffdb7d23-6b2b-58ea-8dc9-ed1bed5d809a",
}
